import { Stack } from "@mui/material"
import React, { Context, ReactElement, ReactNode, useContext } from "react"

interface IMultiPageFormContextValue {
    currentIndex: number
}

/** Component used to display a form with multiple pages, takes a list of elements
 * as it's "children" prop. These elements must be provided in the order they are visited
 * The provided context must supply a 0-based "currentIndex" value
 * so the component can display the desired page. Invalid children will be ignored
 */
interface IMultiPageFormProps {
    children: ReactNode[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: Context<any>
}

const MultiPageForm = ({
    children,
    context,
}: IMultiPageFormProps): ReactElement => {
    const { currentIndex } = useContext(
        context as Context<IMultiPageFormContextValue>
    )

    const childrenToRender = children.filter((child) =>
        React.isValidElement(child)
    )

    return <Stack>{childrenToRender[currentIndex]}</Stack>
}

export default MultiPageForm
